/* 
--- DEVELOPER WARNING ---
This is a generated file.
Any changes you make to this file will not be saved nor git tracked. 
*/

import projectProbe_IconURL from '../RAISE_Logo.png';
import projectProbe_InsetIconURL from '../PRG_Logo.png';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default {
	name: 
  (
    <FormattedMessage
        defaultMessage="Project Probe"
        description="name for the Project Probe extension"
        id="extension.projectProbe.name"
    />
  ),
	description: 
  (
    <FormattedMessage
        defaultMessage="(INTERNAL) An extension for probing the contents of .sb3 files"
        description="description for the Project Probe extension"
        id="extension.projectProbe.description"
    />
  ),
	tags: ["PRG Internal"],
	featured: true,
	extensionId: 'projectProbe',
	iconURL: projectProbe_IconURL,
	insetIconURL: projectProbe_InsetIconURL,
}